import { Alert, Card, Col, Divider, Form, InputNumber, Row, Segmented, Steps, theme, Tooltip, Typography } from 'antd'
import React, { useMemo, useState } from 'react'
import { useLanguage } from 'src/providers/LanguageProvider';

import { InfoCircleOutlined, TeamOutlined, ShopOutlined } from '@ant-design/icons';
import SelectProduct from 'src/components/setupWizard/SelectProduct/SelectProduct';
import ContinuteButton from 'src/components/setupWizard/SelectProduct/ContinuteButton';
import SetupWizardInvoiceProfile from 'src/components/setupWizard/invoiceProfile/SetupWizardInvoiceProfile';
import ResultPage from 'src/components/setupWizard/ResultPage/ResultPage';
const description = 'This is a description.';




const SetupWizardPage = () => {

    const { t } = useLanguage();

    const [currentStep, setCurrentStep] = React.useState(0);


    const [selectedProductId, setSelectedProductId] = React.useState(null);

    const [employeeCount, setEmployeeCount] = useState<number | null>(1);

    const [b2bWebshopEnabled, setB2bWebshopEnabled] = useState<boolean | null>(false); // NEW


    const [selectedProfile, setSelectedProfile] = useState(null);

    const [invoiceProfileData, setInvoiceProfileData] = useState({});

    const [isFinished, setIsFinished] = useState(false);

    const contents = useMemo(() => {
        switch (currentStep) {
            case 0:
                return <SelectProduct b2bWebshopEnabled={b2bWebshopEnabled} setB2bWebshopEnabled={setB2bWebshopEnabled} employeeCount={employeeCount} setEmployeeCount={e => setEmployeeCount(e)} onClick={(e) => selectedProductId == e ? setSelectedProductId(null) : setSelectedProductId(e)} selectedId={selectedProductId} />;
            case 1:
                return <SetupWizardInvoiceProfile setInvoiceProfileData={setInvoiceProfileData} selectedProfile={selectedProfile} setSelectedProfile={setSelectedProfile}/>
            case 2:
                return <ResultPage 
                setIsFinished={setIsFinished}
                data={{
                    selectedProductId,
                    employeeCount,
                    b2bWebshopEnabled,
                    selectedProfile,
                    invoiceProfileData,

                }}
                
                />
            default:
                return null;
        }
    }, [currentStep, selectedProductId,selectedProfile,employeeCount,b2bWebshopEnabled,invoiceProfileData]);

    return (
        <div style={{paddingTop:'20px'}}>
            <Steps
                current={currentStep}
                items={[
                    {
                        title: t('SELECT_PRODUCT'),
                        description: t('SELECT_PRODUCT_DESC'),

                    },
                    {
                        title: t('SELECT_INVOICE_PROFILE'),
                        description : t('SELECT_INVOICE_PROFILE_DESC'),

                    },
                    {
                        title: t('WIZARD_VALIDATE'),
                        description : t('WIZARD_VALIDATE_DESC'),
                    },
                ]}
            />

            <Divider />


            {contents}





            <div style={{ marginTop: '10px' }}>
                <ContinuteButton onClickBack={()=>setCurrentStep(currentStep-1)} onClickContinue={(e) => setCurrentStep(currentStep+1)}  currentStep={currentStep} data={
                    {
                        selectedProductId,
                        employeeCount,
                        b2bWebshopEnabled,
                        selectedProfile
                    }
                } />
            </div>


        </div>
    )
}

export default SetupWizardPage